import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchPOSummary = () => {
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPurchaseOrders = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(`/api/LandingWarehouse/Netsuite/ExecutiveSummary`);
        setPurchaseOrders(response.data || []);
      } catch (err) {
        setError('Failed to fetch purchase orders');
        console.error('Error fetching purchase orders:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPurchaseOrders();
  }, []);

  return { purchaseOrders, loading, error };
};

export default useFetchPOSummary;
